import { render, staticRenderFns } from "./suspensionBar.vue?vue&type=template&id=0d2409f9&scoped=true&"
import script from "./suspensionBar.vue?vue&type=script&lang=ts&"
export * from "./suspensionBar.vue?vue&type=script&lang=ts&"
import style0 from "./suspensionBar.vue?vue&type=style&index=0&id=0d2409f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2409f9",
  null
  
)

export default component.exports